/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PutOrderMemoRequest
 */
export interface PutOrderMemoRequest {
    /**
     * メモ内容
     * @type {string}
     * @memberof PutOrderMemoRequest
     */
    text: string;
}

/**
 * Check if a given object implements the PutOrderMemoRequest interface.
 */
export function instanceOfPutOrderMemoRequest(value: object): value is PutOrderMemoRequest {
    if (!('text' in value) || value['text'] === undefined) return false;
    return true;
}

export function PutOrderMemoRequestFromJSON(json: any): PutOrderMemoRequest {
    return PutOrderMemoRequestFromJSONTyped(json, false);
}

export function PutOrderMemoRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutOrderMemoRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'],
    };
}

export function PutOrderMemoRequestToJSON(json: any): PutOrderMemoRequest {
    return PutOrderMemoRequestToJSONTyped(json, false);
}

export function PutOrderMemoRequestToJSONTyped(value?: PutOrderMemoRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'text': value['text'],
    };
}

